// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/analysis_app_api.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AnalyzeExperimentRequestSchema } from "./analyze_experiment_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_analyze_experiment_request } from "./analyze_experiment_request_pb";
import type { AnalyzeExperimentResponseSchema } from "./analyze_experiment_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_analyze_experiment_response } from "./analyze_experiment_response_pb";
import type { CreateExperimentRequestSchema } from "./create_experiment_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_create_experiment_request } from "./create_experiment_request_pb";
import type { CreateExperimentResponseSchema } from "./create_experiment_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_create_experiment_response } from "./create_experiment_response_pb";
import type { CreateUserRequestSchema } from "./create_user_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_create_user_request } from "./create_user_request_pb";
import type { CreateUserResponseSchema } from "./create_user_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_create_user_response } from "./create_user_response_pb";
import type { GetAssayDataRequestSchema } from "./get_assay_data_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_get_assay_data_request } from "./get_assay_data_request_pb";
import type { GetAssayDataResponseSchema } from "./get_assay_data_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_get_assay_data_response } from "./get_assay_data_response_pb";
import type { GetExperimentDataRequestSchema } from "./get_experiment_data_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_data_request } from "./get_experiment_data_request_pb";
import type { GetExperimentDataResponseSchema } from "./get_experiment_data_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_data_response } from "./get_experiment_data_response_pb";
import type { GetExperimentReportDataRequestSchema } from "./get_experiment_report_data_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_report_data_request } from "./get_experiment_report_data_request_pb";
import type { GetExperimentReportDataResponseSchema } from "./get_experiment_report_data_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_report_data_response } from "./get_experiment_report_data_response_pb";
import type { GetUserRequestSchema } from "./get_user_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_get_user_request } from "./get_user_request_pb";
import type { GetUserResponseSchema } from "./get_user_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_get_user_response } from "./get_user_response_pb";
import type { SaveAssayAsRequestSchema } from "./save_assay_as_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_save_assay_as_request } from "./save_assay_as_request_pb";
import type { SaveAssayAsResponseSchema } from "./save_assay_as_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_save_assay_as_response } from "./save_assay_as_response_pb";
import type { SaveExperimentAsRequestSchema } from "./save_experiment_as_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_save_experiment_as_request } from "./save_experiment_as_request_pb";
import type { SaveExperimentAsResponseSchema } from "./save_experiment_as_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_save_experiment_as_response } from "./save_experiment_as_response_pb";
import type { UpdateAssayDataRequestSchema } from "./update_assay_data_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_update_assay_data_request } from "./update_assay_data_request_pb";
import type { UpdateAssayDataResponseSchema } from "./update_assay_data_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_update_assay_data_response } from "./update_assay_data_response_pb";
import type { UpdateExperimentDataRequestSchema } from "./update_experiment_data_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_update_experiment_data_request } from "./update_experiment_data_request_pb";
import type { UpdateExperimentDataResponseSchema } from "./update_experiment_data_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_update_experiment_data_response } from "./update_experiment_data_response_pb";
import type { UpdateUserRequestSchema } from "./update_user_request_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_update_user_request } from "./update_user_request_pb";
import type { UpdateUserResponseSchema } from "./update_user_response_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_update_user_response } from "./update_user_response_pb";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/analysis_app_api.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_analysis_app_api: GenFile = /*@__PURE__*/
  fileDesc("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", [file_quanterix_simoa_one_analysis_app_api_v1_analyze_experiment_request, file_quanterix_simoa_one_analysis_app_api_v1_analyze_experiment_response, file_quanterix_simoa_one_analysis_app_api_v1_create_experiment_request, file_quanterix_simoa_one_analysis_app_api_v1_create_experiment_response, file_quanterix_simoa_one_analysis_app_api_v1_create_user_request, file_quanterix_simoa_one_analysis_app_api_v1_create_user_response, file_quanterix_simoa_one_analysis_app_api_v1_get_assay_data_request, file_quanterix_simoa_one_analysis_app_api_v1_get_assay_data_response, file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_data_request, file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_data_response, file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_report_data_request, file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_report_data_response, file_quanterix_simoa_one_analysis_app_api_v1_get_user_request, file_quanterix_simoa_one_analysis_app_api_v1_get_user_response, file_quanterix_simoa_one_analysis_app_api_v1_save_assay_as_request, file_quanterix_simoa_one_analysis_app_api_v1_save_assay_as_response, file_quanterix_simoa_one_analysis_app_api_v1_save_experiment_as_request, file_quanterix_simoa_one_analysis_app_api_v1_save_experiment_as_response, file_quanterix_simoa_one_analysis_app_api_v1_update_assay_data_request, file_quanterix_simoa_one_analysis_app_api_v1_update_assay_data_response, file_quanterix_simoa_one_analysis_app_api_v1_update_experiment_data_request, file_quanterix_simoa_one_analysis_app_api_v1_update_experiment_data_response, file_quanterix_simoa_one_analysis_app_api_v1_update_user_request, file_quanterix_simoa_one_analysis_app_api_v1_update_user_response]);

/**
 * @generated from service quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi
 */
export const AnalysisAppApi: GenService<{
  /**
   * Retrieve an assay and its associated data
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.GetAssayData
   */
  getAssayData: {
    methodKind: "unary";
    input: typeof GetAssayDataRequestSchema;
    output: typeof GetAssayDataResponseSchema;
  },
  /**
   * Save a new or modified assay with a new id
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.SaveAssayAs
   */
  saveAssayAs: {
    methodKind: "unary";
    input: typeof SaveAssayAsRequestSchema;
    output: typeof SaveAssayAsResponseSchema;
  },
  /**
   * Update (save) an existing assay
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.UpdateAssayData
   */
  updateAssayData: {
    methodKind: "unary";
    input: typeof UpdateAssayDataRequestSchema;
    output: typeof UpdateAssayDataResponseSchema;
  },
  /**
   * Retrieve an Experiment and its associated data
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.GetExperimentData
   */
  getExperimentData: {
    methodKind: "unary";
    input: typeof GetExperimentDataRequestSchema;
    output: typeof GetExperimentDataResponseSchema;
  },
  /**
   * Save a new or modified experiment with a new id
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.SaveExperimentAs
   */
  saveExperimentAs: {
    methodKind: "unary";
    input: typeof SaveExperimentAsRequestSchema;
    output: typeof SaveExperimentAsResponseSchema;
  },
  /**
   * Save a modified experiment in-place
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.UpdateExperimentData
   */
  updateExperimentData: {
    methodKind: "unary";
    input: typeof UpdateExperimentDataRequestSchema;
    output: typeof UpdateExperimentDataResponseSchema;
  },
  /**
   * Initialize a new experiment
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.CreateExperiment
   */
  createExperiment: {
    methodKind: "unary";
    input: typeof CreateExperimentRequestSchema;
    output: typeof CreateExperimentResponseSchema;
  },
  /**
   * Analyze (or re-analyze) the specified experiment
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.AnalyzeExperiment
   */
  analyzeExperiment: {
    methodKind: "unary";
    input: typeof AnalyzeExperimentRequestSchema;
    output: typeof AnalyzeExperimentResponseSchema;
  },
  /**
   * Get a data report of results for the specified experiment
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.GetExperimentReportData
   */
  getExperimentReportData: {
    methodKind: "unary";
    input: typeof GetExperimentReportDataRequestSchema;
    output: typeof GetExperimentReportDataResponseSchema;
  },
  /**
   * Create a new user record
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof CreateUserRequestSchema;
    output: typeof CreateUserResponseSchema;
  },
  /**
   * Retrieve a user record
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserResponseSchema;
  },
  /**
   * Save a modified user record in-place
   *
   * @generated from rpc quanterix.simoa_one.analysis_app_api.v1.AnalysisAppApi.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_quanterix_simoa_one_analysis_app_api_v1_analysis_app_api, 0);

